import { RouteObject } from "react-router-dom";
import { NotFound } from "src/routes/NotFound";
import { AddProductOfferingConfigPage } from "src/routes/libraries/product-offering-configs/AddProductOfferingConfigPage";
import { ProductOfferingConfigsPage } from "src/routes/libraries/product-offering-configs/ProductOfferingConfigsPage";
import { AppShell } from "src/routing/components/AppShell";
import { BeamNavbarLayout } from "src/routing/components/layouts/BeamNavbarLayout";
import { GlobalNavLayout } from "src/routing/components/layouts/GlobalNavLayout";
import { ScrollableParentLayout } from "src/routing/components/layouts/ScrollableParentLayout";
import * as productOfferingConfigsPaths from "src/routing/domains/libraries/product-offering-configs/productOfferingConfigsPaths";

/**
 * `/libraries/product-offering-configs/*` route tree.
 *
 * Role: data router domain route.
 *
 * Two layout stacks coexist during migration:
 * - **New (Beam):** `AppShell` → `BeamNavbarLayout` → index list (`PageHeaderLayout` / `GridTableLayout`)
 * - **Legacy:** `AppShell` → `GlobalNavLayout` → `ScrollableParentLayout` → add/edit pages
 *
 * Project and development config lists reuse `ProductOfferingConfigsPageView` under their Beam side nav.
 */
export const productOfferingConfigsRoute: RouteObject = {
  path: productOfferingConfigsPaths.globalProductOfferingConfigsRoute.path,
  Component: AppShell,
  children: [
    { Component: BeamNavbarLayout, children: [{ index: true, Component: ProductOfferingConfigsPage }] },
    {
      Component: GlobalNavLayout,
      children: [
        {
          Component: ScrollableParentLayout,
          children: [
            {
              path: productOfferingConfigsPaths.productOfferingConfigEditRoute.path,
              Component: AddProductOfferingConfigPage,
            },
            {
              path: productOfferingConfigsPaths.productOfferingConfigRoute.path,
              Component: AddProductOfferingConfigPage,
            },
          ],
        },
      ],
    },
    { path: "*", Component: NotFound },
  ],
};
